define.alias("ember-composable-helpers/helpers/map", "media/helpers/map");